var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeathStarFilled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 1C5.47713 1 1 5.47713 1 11C1 11.4317 1.03654 11.8542 1.08958 12.2715C3.99496 13.1457 7.37075 13.6667 11 13.6667C14.6293 13.6667 18.005 13.1457 20.9104 12.2715C20.9635 11.8542 21 11.4317 21 11C21 5.47713 16.5229 1 11 1ZM8.33333 10.3333C6.49479 10.3333 5 8.83854 5 7C5 5.16146 6.49479 3.66667 8.33333 3.66667C10.1719 3.66667 11.6667 5.16146 11.6667 7C11.6667 8.83854 10.1719 10.3333 8.33333 10.3333ZM1.39642 13.767C2.59767 17.9424 6.43825 21 11 21C15.5618 21 19.4023 17.9424 20.6036 13.767C17.749 14.5489 14.4952 15 11 15C7.50479 15 4.25096 14.5489 1.39642 13.767ZM8.33333 6C7.78125 6 7.33333 6.44792 7.33333 7C7.33333 7.55208 7.78125 8 8.33333 8C8.88542 8 9.33333 7.55208 9.33333 7C9.33333 6.44792 8.88542 6 8.33333 6Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeathStarFilled);
export default __webpack_public_path__ + "static/media/deathStarFilled.0713c4926aa814682688090cdf1dc201.svg";
export { ForwardRef as ReactComponent };